import { render, staticRenderFns } from "./claimWorkflowList.vue?vue&type=template&id=c8caa980"
import script from "./claimWorkflowList.vue?vue&type=script&lang=js"
export * from "./claimWorkflowList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports